import { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import UseModal from 'hooks/use-modal';

import { useQuery } from 'react-query';
import { userProfileService } from 'services/auth';
import { isUserLoggedIn, getAccessToken } from 'utils/authentication';
import { MOBILE_FULLSCREEN, NORMAL } from '@core/constants/ModalTypes';

import Avatar from 'components/pages/profile/Avatar';
import FullNameForm from 'components/pages/profile/FullNameForm';
import JobForm from 'components/pages/settings/jobform/JobForm';
import Modal from '@core/components/Modal/Modal';

// import icons
import SmsIcon from 'assets/icons/sms-icon.svg';
import CheckIcon from 'assets/icons/check-icon.svg';
import { Edit2 } from 'iconsax-react';

import classes from './ProfileInfo.module.scss';


const ProfileInfo = ({ data, refetch, type = '', toast }) => {
    const { showModal, destroyModal, show } = UseModal();
    const { showModal: showModalJob, destroyModal: destroyModalJob, show: showJob } = UseModal();
    return (
        <>
            <div className={`${classes['user-box']}`}>
                <div className={classes['user-image-wrapper']}>
                    <Avatar imageURL={data.data.image} refetchHandler={refetch} size='small' />
                </div>
                <div className={`${classes['info']}`}>
                    {data.data.is_name_verified ? (
                        <div
                            className={`${classes['fill-name']}`}>{`${data.data.first_name} ${data.data.last_name}`}</div>
                    ) : (
                        <div
                            className={`${classes['empty-name']}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => showModal()}>
                            Add your name
                        </div>
                    )}
                    <div className={`${classes['user-email']}`}>
                        {data.data.email}
                        {data.data.is_verified && <CheckIcon />}
                    </div>
                    {type === 'myAccount' && (
                        <div className={`${classes['job-wrapper']}`}>
                            <div>
                                <span>
                                    {data.data.job_role ? data.data.job_role : 'Job Role Title'}
                                </span>
                                {data.data.years_of_experience_label ? `/ ${data.data.years_of_experience_label}` : ''}
                            </div>
                            <Edit2 role="button" onClick={() => showModalJob()} size={16} color='#666664' variant='TwoTone' />
                        </div>
                    )}
                </div>
            </div>
            {
                !data.data.is_verified && (
                    <div className={`${classes['email-not-verified']}`}>
                        <div className={`${classes['msg-container']}`}>
                            <SmsIcon />
                            <div className={`${classes['text']}`}>Email not verified yet</div>
                        </div>
                        <div className={`${classes['action-container']}`}>
                            <Link href="/verification">Verify now</Link>
                            <div className={`${classes['icon']}`}></div>
                        </div>
                    </div>
                )
            }
            <Modal show={show} closeHandler={destroyModal} type={MOBILE_FULLSCREEN}>
                <FullNameForm closeModal={destroyModal} refetchHandler={refetch} />
            </Modal>
            <Modal show={showJob} closeHandler={destroyModalJob} type={MOBILE_FULLSCREEN}>
                <JobForm closeHandler={destroyModalJob} refetchHandler={refetch} toast={toast} />
            </Modal>
        </>
    );
};

export default ProfileInfo;